<script>
  export let anyActive;
  export let even;
</script>

<div
  class="timeline {even == true ? 'even' : 'odd'} {anyActive
    ? 'event-active'
    : ''}"
/>

<style>
  .timeline {
    position: absolute;
    width: 1px;
    background: var(--soft-white);
    opacity: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 300ms linear 150ms;
    /* HEIGHT TRANSITIONS ARE LOW PERFORMANCE BECAUSE OF PAINTING */
    /* height: 1%; */
    /* transition: opacity 300ms linear, height 300ms ease 300ms; */
  }

  .even {
    bottom: 0;
  }

  .odd {
    top: 0;
  }

  :global(.swiper-slide-active .timeline) {
    height: 48%;
    opacity: 1;
  }

  :global(.swiper-slide-active .need-extra-height .timeline) {
    height: 78%;
  }

  .even::after {
    position: absolute;
    content: "";
    right: -5px;
    width: 0;
    height: 0;
    border-bottom: 5px solid white;
    border-top: 5px solid transparent;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: -5px;
  }

  .odd::after {
    position: absolute;
    content: "";
    right: -5px;
    width: 0;
    height: 0;
    border-top: 5px solid white;
    border-bottom: 5px solid transparent;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    bottom: -5px;
  }

  /* MOBILE */
  @media screen and (max-width: 767px) {
    :global(.swiper-slide-active .timeline) {
      height: 79% !important;
      opacity: 1;
    }

    :global(.swiper-slide-active .need-extra-height .timeline) {
      height: 79% !important;
    }
  }

  .event-active {
    opacity: 0;
  }
</style>
